/* Gerado por tools/import-pokeidle-loot.mjs — stubs EN; mesclar nos locales. */
export const LOOT_I18N_STUBS = {
  'items.air-tank.name': "Air Tank",
  'items.armadillo-claw.name': "Armadillo Claw",
  'items.bag-of-pollen.name': "Bag of Pollen",
  'items.band-aid.name': "Band Aid",
  'items.bat-wing.name': "Bat Wing",
  'items.bee-sting.name': "Bee Sting",
  'items.drop-champion-belt.name': "Belt of Champion",
  'items.bird-beak.name': "Bird Beak",
  'items.bitten-apple.name': "Bitten Apple",
  'items.blue-fish-fin.name': "Blue Fish Fin",
  'items.blue-vines.name': "Blue Vines",
  'items.drop-bone.name': "Bone",
  'items.drop-poison-bottle.name': "Bottles of Poison",
  'items.drop-bug-antenna.name': "Bug Antenna",
  'items.bug-gosme.name': "Bug Gosme",
  'items.bug-venom.name': "Bug Venom",
  'items.bulb.name': "Bulb",
  'items.bull-tail.name': "Bull Tail",
  'items.butterfly-wing.name': "Butterfly Wing",
  'items.chansey-egg.name': "Chansey Egg",
  'items.chicken-feet.name': "Chicken Feet",
  'items.colored-feather.name': "Colored Feather",
  'items.comb.name': "Comb",
  'items.crab-claw.name': "Crab Claw",
  'items.crystal-cube.name': "Crystal Cube",
  'items.crystal-tail.name': "Crystal Tail",
  'items.dark-gem.name': "Dark Gem",
  'items.diving-mask.name': "Diving Mask",
  'items.dodo-cube.name': "Dodo Cube",
  'items.dodrio-feather.name': "Dodrio Feather",
  'items.dome-fossil.name': "Dome Fossil",
  'items.dragon-scale.name': "Dragon Scale",
  'items.dragon-tail.name': "Dragon Tail",
  'items.drop-dragon-tooth.name': "Dragon Tooth",
  'items.earth-ball.name': "Earth Ball",
  'items.drop-electric-box.name': "Electric Box",
  'items.electric-rat-tail.name': "Electric Rat Tail",
  'items.electric-tail.name': "Electric Tail",
  'items.enchanted-gem.name': "Enchanted Gem",
  'items.drop-essence-fire.name': "Essence of Fire",
  'items.farfetchd-stick.name': "Farfetchd Stick",
  'items.drop-feather.name': "Feather",
  'items.female-ear.name': "Female Ear",
  'items.fins.name': "Fins",
  'items.fire-horse-foot.name': "Fire Horse Foot",
  'items.fire-tail.name': "Fire Tail",
  'items.fish-fin.name': "Fish Fin",
  'items.drop-fox-tail.name': "Fox Tail",
  'items.fur.name': "Fur",
  'items.future-orb.name': "Future Orb",
  'items.drop-ghost-essence.name': "Ghost Essence",
  'items.giant-fin.name': "Giant Fin",
  'items.giant-piece-of-fur.name': "Giant Piece of Fur",
  'items.giant-ruby.name': "Giant Ruby",
  'items.goggles.name': "Goggles",
  'items.gosme.name': "Gosme",
  'items.gyarados-tail.name': "Gyarados Tail",
  'items.helix-fossil.name': "Helix Fossil",
  'items.horn.name': "Horn",
  'items.horn-drill.name': "Horn Drill",
  'items.drop-ice-orb.name': "Ice Orb",
  'items.iron-bracelet.name': "Iron Bracelet",
  'items.kanga-ear.name': "Kanga Ear",
  'items.karate-duck.name': "Karate Duck",
  'items.kick-machine.name': "Kick Machine",
  'items.leaves.name': "Leaves",
  'items.linearly-guided-hypnosis.name': "Linearly Guided Hypnosis",
  'items.locksmith-of-shell.name': "Locksmith of Shell",
  'items.drop-luck-medal.name': "Luck Medallion",
  'items.magikarp-fin.name': "Magikarp Fin",
  'items.magma-foot.name': "Magma Foot",
  'items.magnet.name': "Magnet",
  'items.magnetic-cube.name': "Magnetic Cube",
  'items.male-ear.name': "Male Ear",
  'items.martial-arts-scroll.name': "Martial Arts Scroll",
  'items.microphone.name': "Microphone",
  'items.mimic-clothes.name': "Mimic Clothes",
  'items.mushroom.name': "Mushroom",
  'items.nail.name': "Nail",
  'items.neodymium-magnet.name': "Neodymium Magnet",
  'items.old-amber.name': "Old Amber",
  'items.onix-tail.name': "Onix Tail",
  'items.piece-of-diglett.name': "Piece of Diglett",
  'items.piece-of-steel.name': "Piece of Steel",
  'items.pinsir-horn.name': "Pinsir Horn",
  'items.plant-foot.name': "Plant Foot",
  'items.plant-tail.name': "Plant Tail",
  'items.pot-of-lava.name': "Pot Of Lava",
  'items.pot-of-lava.name': "Pot of Lava",
  'items.pot-of-moss-bug.name': "Pot of Moss Bug",
  'items.psychic-spoon.name': "Psychic Spoon",
  'items.psyduck-mug.name': "Psyduck Mug",
  'items.punch-machine.name': "Punch Machine",
  'items.rat-tail.name': "Rat Tail",
  'items.red-wing.name': "Red Wing",
  'items.rubber-ball.name': "Rubber Ball",
  'items.ruby.name': "Ruby",
  'items.sandbag.name': "Sandbag",
  'items.screw.name': "Screw",
  'items.scythe.name': "Scythe",
  'items.seahorse-tail.name': "Seahorse Tail",
  'items.seal-tail.name': "Seal Tail",
  'items.drop-seed.name': "Seed",
  'items.ski-poles.name': "Ski Poles",
  'items.slow-tail.name': "Slow Tail",
  'items.small-stone.name': "Small Stone",
  'items.snake-tail.name': "Snake Tail",
  'items.snow-skis.name': "Snow Skis",
  'items.snowball.name': "Snowball",
  'items.squirtle-hull.name': "Squirtle Hull",
  'items.sticky-hand.name': "Sticky Hand",
  'items.drop-stone-orb.name': "Stone Orb",
  'items.strange-flower.name': "Strange Flower",
  'items.strange-rock.name': "Strange Rock",
  'items.strange-spike.name': "Strange Spike",
  'items.strange-thing.name': "Strange Thing",
  'items.straw.name': "Straw",
  'items.tentacruel-tentacle.name': "Tentacruel Tentacle",
  'items.tongue.name': "Tongue",
  'items.drop-tooth.name': "Tooth",
  'items.topknot.name': "Topknot",
  'items.drop-ghost-trace.name': "Traces of Ghost",
  'items.venom-flute.name': "Venom Flute",
  'items.drop-water-gem.name': "Water Gem",
  'items.water-pendant.name': "Water Pendant",
  'items.wool-ball.name': "Wool Ball",
  'items.azure-shard.name': "Azure Shard",
  'items.cerise-shard.name': "Cerise Shard",
  'items.corrupted-ice-orb.name': "Corrupted Ice Orb",
  'items.corrupted-pot-of-moss-bug.name': "Corrupted Pot of Moss Bug",
  'items.cyan-nightmare-gem.name': "Cyan Nightmare Gem",
  'items.farfetchd-stick.name': "Farfetch'd Stick",
  'items.googles.name': "Googles",
  'items.harlequin-shard.name': "Harlequin Shard",
  'items.malefic-essence.name': "Malefic Essence",
  'items.metal-scraps.name': "Metal Scraps",
  'items.naturia-essence.name': "Naturia Essence",
  'items.neutral-essence.name': "Neutral Essence",
  'items.nightmare-gem.name': "Nightmare Gem",
  'items.nightmare-ore.name': "Nightmare Ore",
  'items.psychic-mustache.name': "Psychic Mustache",
  'items.psycraft-essence.name': "Psycraft Essence",
  'items.seavell-essence.name': "Seavell Essence",
  'items.tm-disk-piece.name': "TM Disk Piece",
  'items.rare-pokemon-picture.name': "Rare Pokémon Picture",
  'items.pheromone.name': "Strange Pheromone",
  'items.ancient-stone.name': "Ancient Stone",
  'items.cocoon-stone.name': "Cocoon Stone",
  'items.crystal-stone.name': "Crystal Stone",
  'items.darkness-stone.name': "Darkness Stone",
  'items.earth-stone.name': "Earth Stone",
  'items.enigma-stone.name': "Enigma Stone",
  'items.feather-stone.name': "Feather Stone",
  'items.fire-stone.name': "Fire Stone",
  'items.heart-stone.name': "Heart Stone",
  'items.ice-stone.name': "Ice Stone",
  'items.leaf-stone.name': "Leaf Stone",
  'items.metal-stone.name': "Metal Stone",
  'items.punch-stone.name': "Punch Stone",
  'items.rock-stone.name': "Rock Stone",
  'items.thunder-stone.name': "Thunder Stone",
  'items.venom-stone.name': "Venom Stone",
  'items.water-stone.name': "Water Stone",
  'items.moon-stone.name': "Moon Stone",
  'items.sun-stone.name': "Sun Stone",
  'items.rough-gemstone.name': "Rough Gemstone",
};

